// extracted by mini-css-extract-plugin
export default {"form":"UserCreateModal_form__m47z4"};